import React, { useContext } from 'react';
import { KeyboardDetectionContext } from '@spotify-internal/encore-web';
export var ReactDatesThemeProvider = function (_a) {
    var children = _a.children;
    var isUsingKeyboard = useContext(KeyboardDetectionContext).isUsingKeyboard;
    return (React.createElement("div", { "data-datepicker": true, "data-using-keyboard": isUsingKeyboard }, children));
};
//# sourceMappingURL=ReactDatesThemeProvider.js.map